module.exports = __webpack_public_path__ + "img/trial.394615e7.png";